let _ = require('../_.js');
let $ = jQuery;

// Functions for setting the current session, and getting associated registration data.
// Most notably, includes function on_registrant_data_update() which calls the provided callback
// whenever the registrant is set or it's data is updated.

let _last_registration_revision = null;

_.AuctionUI_Session = class AuctionUI_Session {

    static _session_data = {};

    static _session_callbacks = [];

    static _has_init = false;
    static _session_is_loaded = false;

    static _ws_registrant_token = null;
    static _ws_hooked = false;

    // Called when user signs up, signs in, or when a signed in registrant record has updated
    static async refresh(force = false) {
        let that = _.AuctionUI_Session;
        await _.mutex('session-refresh', async function () {

            that._has_init = true;

            console.log("Session refresh");

            let has_changed = false;

            // returns registrant_id, registration_id, backend_user, ws_registrant_token
            let session_ids = await _.backend_ajax('session', 'get', { auction_id: _.AuctionUI.auction_id() });

            that._set_ws_registrant_token(session_ids ? session_ids.ws_registrant_token : null);

            // Handle unified session response
            if (session_ids) {
                // Store backend user info if present
                if (session_ids.backend_user) {
                    localStorage.setItem('landproz_backend_user', JSON.stringify(session_ids.backend_user));
                } else {
                    localStorage.removeItem('landproz_backend_user');
                }
            }

            if (!session_ids || (!session_ids.registrant_id && !session_ids.user_id)) {
                if (_.AuctionUI_Session.get_token_cookie()) {
                    _.AuctionUI_Session.logout(); // Deletes cookie

                    // Hack... this should do a better check than this to see if we need to refresh ui.
                    if ($(".landproz-account-global-link-signed-in").is(":visible")) {
                        has_changed = true;
                    }
                }
            }

            if (session_ids) {

                // Remove incorrect registrant (sign out)
                if (that._session_data.registrant && (!session_ids.registrant_id || session_ids.registrant_id != that._session_data.registrant.id)) {
                    that._session_data.registrant = null;
                    has_changed = true;
                }

                // Remove incorrect registration (sign out or force remove from auction)
                if (that._session_data.registration && (!session_ids.registration_id || session_ids.registration_id != that._session_data.registration.id)) {
                    that._session_data.registration = null;
                    has_changed = true;
                }

                let backend_user = _.AuctionUI_Session.get_backend_user();
                // Remove incorrect backend user
                if (backend_user && (!session_ids.user_id || session_ids.user_id != backend_user.id)) {
                    localStorage.removeItem('landproz_backend_user');
                    has_changed = true;
                }

                // Load registrant and registration concourently
                if (session_ids.registrant_id) App_Models_Registrant.get_private(session_ids.registrant_id);
                if (session_ids.registration_id) App_Models_AuctionRegistration.get_private(session_ids.registration_id);

                // Clear registrant if backend user has no registrant_id
                if (!session_ids.registrant_id && that._session_data.registrant) {
                    that._session_data.registrant = null;
                    _.ac_state.registrant = null;
                    has_changed = true;
                }

                // Resolve registrant result
                if (session_ids.registrant_id && !that._session_data.registrant) {
                    that._session_data.registrant = await App_Models_Registrant.get_private(session_ids.registrant_id);
                    _.ac_state.registrant = that._session_data.registrant;
                    if (that._session_data.registrant) {
                        // Subscribe to registrant.  Registrant will be touched whenever a registration is updated.
                        that._session_data.registrant.subscribe(true, _.AuctionUI_Session.refresh, 1);
                    }
                    has_changed = true;
                }

                // Did the registrant agree to the terms and conditions?
                // Debug logging for TOC check
                if (that._session_data.registrant && that._session_data.registrant.id) {
                    console.log('TOC Check:', {
                        'has_ac_state': !!_.ac_state,
                        'has_property': !!(_.ac_state && _.ac_state.property),
                        'registrant_id': that._session_data.registrant.id,
                        'user_accepted_terms': that._session_data.registrant.user_accepted_terms,
                        'terms_have_changed': that._session_data.registrant.terms_have_changed,
                        'will_show_modal': _.ac_state && _.ac_state.property && ((!that._session_data.registrant.user_accepted_terms) || that._session_data.registrant.terms_have_changed)
                    });
                }

                if (_.ac_state && _.ac_state.property &&
                    that._session_data.registrant &&
                    that._session_data.registrant.id &&
                    ((!that._session_data.registrant.user_accepted_terms) || that._session_data.registrant.terms_have_changed)) {

                    // Show TOC modal but don't return - let session callbacks fire to update UI
                    // Use set_unhidable to prevent the notification system from dismissing this critical modal
                    console.log('Showing TOC modal');
                    _.Notification_Force_Accept_Site_Terms.show();
                }

                // Resolve registration result
                if (session_ids.registration_id && !that._session_data.registration) {
                    // Detect registration assigned
                    that._session_data.registration = await App_Models_AuctionRegistration.get_private(session_ids.registration_id);
                    _.ac_state.registration = that._session_data.registration;
                    has_changed = true;
                } else if (session_ids.registration_id && that._session_data.registration) {
                    // Detect updated registration (maybe approved?)
                    if (_last_registration_revision != that._session_data.registration._revision) {
                        _last_registration_revision = that._session_data.registration._revision;
                        has_changed = true;
                    }
                }

                _.AuctionUI_Session._session_is_loaded = true;


            }

            // If anything has changed, call all registered callbacks that update the UI with session information
            if (has_changed || force) {
                // console.log("New session data", that._session_data);
                for (let i in that._session_callbacks) {
                    that._session_callbacks[i](that._session_data);
                }
            }
        });
    }

    // WS identity: the signed token session/get returns for a logged-in bidder ("registrant_id|expires|hmac").
    // Sent in 'registrant_auth' when it changes (login, logout: null) and on every (re)connect; one
    // within an hour of expiry is renewed through refresh() first. Without it the WS server counts
    // this page as a viewer only (no idle / poised / lag on the clerk, no registrant notifications).
    static _set_ws_registrant_token(token) {
        let that = _.AuctionUI_Session;
        token = token || null;
        if (!that._ws_hooked) {
            that._ws_hooked = true;
            _.on_websocket_connected(function () {
                if (!that._ws_registrant_token) return;
                if (parseInt(that._ws_registrant_token.split('|')[1]) * 1000 - Date.now() < 3600 * 1000) {
                    _.AuctionUI_Session.refresh(); // Sends the renewed token
                } else {
                    _.websocket_send("registrant_auth", { token: that._ws_registrant_token });
                }
            });
        }
        if (token === that._ws_registrant_token) return;
        that._ws_registrant_token = token;
        _.websocket_send("registrant_auth", { token: token });
    }

    /* Gets the current active session for the user */
    static async get_registrant() {
        if (!this._has_init) {
            await this.refresh();
        }

        // Return null if registrant doesn't have a valid id (e.g., backend users)
        return (this._session_data.registrant && this._session_data.registrant.id) ? this._session_data.registrant : null;
    }

    /* Gets the current active session for the user */
    static async get_registration() {
        if (!this._has_init) {
            await this.refresh();
        }

        return this._session_data.registration;
    }

    /**
     * Document me
     */
    static session_updated_handler = async function (callback) {
        if (!this._has_init) {
            await this.refresh();
        }

        this._session_callbacks.push(callback);

        callback(this._session_data);
    }

    static async logout() {
        // Staff user signed in on the website (read before the server-side logout clears it)
        let backend_user = this.get_backend_user();

        // Call server-side logout to invalidate unified session token
        try {
            await _.backend_ajax('session', 'logout', {});
        } catch (e) {
            console.warn('Server-side logout failed:', e);
        }

        // Only when the website session was a staff user: also call ACE logout directly
        // from the browser to destroy the ACE session cookie (which lives on the ACE
        // domain, not WordPress domain). The server-side proxy call above can't clear it
        // because it doesn't have the browser's ACE session cookie. A registrant-only
        // website session leaves ACE alone. no-cors: the cookie is sent and the
        // response's Set-Cookie applies, but the response is never read -- ACE never
        // lets another origin read a cookie-authenticated response.
        if (backend_user) {
            try {
                let ace_url = _.get_ace_backend_url();
                await fetch(ace_url + '/logout', {
                    method: 'GET',
                    credentials: 'include',
                    mode: 'no-cors',
                });
            } catch (e) {
                console.warn('ACE session logout failed:', e);
            }
        }

        localStorage.removeItem('landproz_backend_user');
        this.delete_token_cookie();
        this._set_ws_registrant_token(null);
    }

    static set_token_cookie(token, expirationDays = 30) {
        var date = new Date();
        date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + date.toUTCString();
        document.cookie = "ac-token=" + token + "; " + expires + "; path=/";
    }

    static get_token_cookie() {
        var name = "ac-token=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var cookies = decodedCookie.split(';');

        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }

        return null;
    }

    static delete_token_cookie() {
        document.cookie = "ac-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }

    static get_backend_user() {
        return JSON.parse(localStorage.getItem('landproz_backend_user') || 'null');
    }

}

